import React from 'react';
import { FacebookIcon, XIcon, RssIcon, LinkedInIcon, YouTubeIcon, RokuIcon } from "@argo/ui-elements";
export const fallbackCopyrightLinks = [{
  name: 'Copyrights & Trademarks',
  url: '/company/copyrights-and-trademarks/',
  omnitureTag: 'copyright_footer',
  googleTag: 'text-link::slp_copyrights-and-trademarks::copyrightand-trademarks',
  pixallTag: 'text-link::slp_copyrights-and-trademarks::copyrightand-trademarks'
}, {
  name: 'Vehicle Photos © Evox Images'
}, {
  name: 'Terms of Service',
  url: '/company/terms-of-service/',
  omnitureTag: 'tos_footer',
  googleTag: 'text-link::slp_terms-of-service::terms-of-service',
  pixallTag: 'text-link::slp_terms-of-service::terms-of-service'
}, {
  name: 'Privacy Statement',
  url: '/company/privacy-policy/',
  javascriptFunc: 'caiprivacy.privacyStatement',
  omnitureTag: 'privacy_footer',
  googleTag: 'text-link::slp_privacy-policy::privacy-policy',
  pixallTag: 'text-link::slp_privacy-policy::privacy-policy'
}, {
  name: 'Linking Policy',
  url: '/company/linking-policy/',
  rel: 'nofollow',
  omnitureTag: 'linkingpolicy_footer',
  googleTag: 'text-link::slp_linking-policy::linking-policy',
  pixallTag: 'text-link::slp_linking-policy::linking-policy'
}, {
  name: 'Accessibility Statement',
  url: '/legal/accessibility-statement/',
  omnitureTag: 'accessibility_footer'
}];
export const fallbackSocialLinks = [{
  icon: React.createElement(FacebookIcon, {
    color: 'white',
    size: "24",
    title: "Facebook"
  }),
  url: '//www.facebook.com/kbb',
  altText: 'Facebook',
  dataPartner: 'facebook',
  omnitureTag: 'share_footer',
  ariaLabel: 'Facebook Icon'
}, {
  icon: React.createElement(XIcon, {
    color: 'white',
    size: "24",
    title: "X"
  }),
  url: '//x.com/kelleybluebook',
  altText: '@kelleybluebook',
  dataPartner: 'x',
  omnitureTag: 'share_footer',
  ariaLabel: 'X Icon'
}, {
  icon: React.createElement(RssIcon, {
    color: 'white',
    size: "24",
    title: "RSS"
  }),
  url: '/feed/',
  altText: 'RSS',
  omnitureTag: 'rss_footer',
  ariaLabel: 'RSS Icon'
}, {
  icon: React.createElement(LinkedInIcon, {
    color: 'white',
    size: "24",
    title: "LinkedIn"
  }),
  url: '//www.linkedin.com/company/kelley-blue-book',
  altText: 'LinkedIn',
  dataPartner: 'linkedin',
  omnitureTag: 'share_footer',
  ariaLabel: 'LinkedIn Icon'
}, {
  icon: React.createElement(YouTubeIcon, {
    color: 'white',
    size: "24",
    title: "YouTube"
  }),
  url: '//www.youtube.com/kbb',
  altText: 'YouTube',
  dataPartner: 'youtube',
  omnitureTag: 'share_footer',
  ariaLabel: 'YouTube Icon'
}, {
  icon: React.createElement(RokuIcon, {
    color: 'white',
    size: "24",
    title: "Roku"
  }),
  url: '//channelstore.roku.com/details/69334/kelley-blue-book-tv',
  altText: 'Roku',
  dataPartner: 'roku',
  omnitureTag: 'share_footer',
  ariaLabel: 'Roku Icon'
}];